export const useSearchParams = () => {
    const searchParams = new URLSearchParams(window.location.search);

    const callId = searchParams.get('callId') ?? ''; /** '317178' */
    const domain = searchParams.get('domain') ?? ''; /** 'demo.t3' */
    const email = searchParams.get('email') ?? ''; /** 'admin@linapp.udeskt1.com' */
    const timestamp = searchParams.get('timestamp') ?? ''; /** '1726280965910' */
    const sign = searchParams.get('sign') ?? ''; /** '94a3075e8d9c4eddf878c0a615eb5d7ca8aa7f7d' */

    return {
        callId,
        domain,
        email,
        timestamp,
        sign,
    };
};
